import { Button } from '@innovyze/stylovyze';
import { Paper } from '@mui/material';
import { rem } from '@innovyze/stylovyze';
import styled from 'styled-components';

const columns = 4;

export const Wrapper = styled(Paper)`
	margin-top: ${rem(15)};
	display: grid;
	grid-template-columns: ${Array(columns)
		.fill('minmax(0, 1fr)')
		.join(' ')};
	column-gap: ${rem(10)};
	border-left: 6px solid #00abd1;
	padding: ${rem(5)} ${rem(10)};
`;

export const SimulationName = styled.div`
	grid-column: span 3;
	font-size: ${rem(18)};
	line-height: ${rem(24)};
	font-weight: bold;
`;

export const SimulationActionButton = styled(Button)`
	grid-row: 1 / span 2;
	grid-column: 4;
	justify-self: end;
	align-self: center;
`;
